import { openPopupAction } from 'editor/src/store/app/slice';
import type { Thunk } from 'editor/src/store/hooks';

const closePopupOperation = (): Thunk => (dispatch) => {
  dispatch(openPopupAction({ open: undefined }));
};

export default closePopupOperation;
